import type { Listing } from '@thevillages/schemas';

export function ComputedListingBaths(listing: Listing): string {
  if (!listing.baths?.full) {
    return '';
  }

  const _half = listing.baths.half ? '.5' : '';

  return `${listing.baths.full}${_half}`;
}
